import { Network } from "@/interfaces/network";
import { NearAirdropContract } from "@/services/contracts/near/Airdrops";
import { AirdropResponse } from "@/services/rpc/near";

export const retrieveAirdrop = async (
  network: Network,
  id: number,
  address: string | null,
): Promise<AirdropResponse | undefined> => {
  switch (network) {
    case Network.NEAR: {
      if (!address) return;
      const response = await NearAirdropContract.get_airdrop(id);
      return response;
    }
    default:
      return;
  }
};
